import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, setToken, errMsg } from "@/lib/api";

export const ChangePasswordForm = ({ forced, onDone, onCancel }) => {
  const [f, setF] = useState({ current: "", next: "", again: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.again) { setError("The new passwords don't match."); return; }
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/change-password", { current: f.current, new: f.next });
      setToken(data.token);
      toast.success("Password changed.");
      onDone(data.user);
    } catch (err) { setError(errMsg(err, "Could not change the password.")); }
    finally { setBusy(false); }
  };

  return (
    <form className="lg-card lg-fade" onSubmit={submit} data-testid="change-password-form">
      <div className="lg-eyebrow"><KeyRound size={12} style={{ display: "inline", marginRight: 6 }} />{forced ? "First sign-in" : "Your account"}</div>
      <h1 style={{ fontSize: 24, margin: "10px 0 6px" }}>{forced ? "Set your own password" : "Change password"}</h1>
      <p className="lg-lead" style={{ marginBottom: 18, fontSize: 14 }}>
        {forced ? "You signed in with a temporary password. Choose your own to open the Command Deck." : "At least 8 characters."}
      </p>
      {[["current", forced ? "Temporary password" : "Current password"], ["next", "New password (8+ characters)"], ["again", "New password again"]].map(([k, l]) => (
        <div className="lg-field" style={{ marginBottom: 12 }} key={k}>
          <label htmlFor={`cp-${k}`}>{l}</label>
          <input id={`cp-${k}`} className="lg-input" type="password" value={f[k]} onChange={set(k)} required minLength={k === "current" ? 1 : 8}
            autoComplete={k === "current" ? "current-password" : "new-password"} data-testid={`change-password-${k}`} />
        </div>
      ))}
      {error && <p className="lg-err" style={{ marginBottom: 12 }} data-testid="change-password-error">{error}</p>}
      <div style={{ display: "flex", gap: 8 }}>
        <button className="lg-btn" style={{ flex: 1 }} disabled={busy} data-testid="change-password-submit">{busy ? "Saving…" : "Save password"}</button>
        {onCancel && <button type="button" className="lg-btn ghost" onClick={onCancel} data-testid="change-password-cancel">{forced ? "Sign out" : "Cancel"}</button>}
      </div>
    </form>
  );
};
